// src/utils/sortHelpers.js

export function sortiereProdukte(produkte, field, direction) {
  return [...produkte].sort((a, b) => {
    let valA = a[field] ?? '';
    let valB = b[field] ?? '';
    // Zahlen korrekt sortieren
    if (field === 'menge' || field === 'tageBisVerfall') {
      valA = parseFloat(valA) || 0;
      valB = parseFloat(valB) || 0;
    } else {
      valA = String(valA).toLowerCase();
      valB = String(valB).toLowerCase();
    }
    if (valA < valB) return direction === 'asc' ? -1 : 1;
    if (valA > valB) return direction === 'asc' ? 1 : -1;
    return 0;
  });
}


